import React from 'react';
import { Badge } from 'features/catalog/useBadges';
import { BadgeThumb } from 'shared/components/BadgeThumb';
import { PageProfileSearch } from 'features/profiles/PageProfileSearch';
import './ProfileIdentitySearch.css';

interface ProfileIdentitySearchProps {
  selectedProfileId?: string | null;
  onSelectProfile: (profileId: string) => void;
  onClear?: () => void;
  /** Coolest badge image, or the Talos logo placeholder. */
  avatarSrc: string;
  /** When set, hover reveals rarity on the avatar (same as gallery badges). */
  avatarBadge?: Badge | null;
  avatarAlt?: string;
  onAvatarClick?: () => void;
  /** Email / stats / gallery title under the selector. */
  children?: React.ReactNode;
  defaultMenuOpen?: boolean;
  autoFocus?: boolean;
}

/** Shared avatar + profile selector used by galleries and profile pages. */
export const ProfileIdentitySearch: React.FC<ProfileIdentitySearchProps> = ({
  selectedProfileId = null,
  onSelectProfile,
  onClear,
  avatarSrc,
  avatarBadge = null,
  avatarAlt = '',
  onAvatarClick,
  children,
  defaultMenuOpen,
  autoFocus,
}) => {
  const avatar =
    avatarBadge != null ? (
      <BadgeThumb badge={avatarBadge} size="lg" alt={avatarAlt} imageClassName="profile-identity-search-avatar" />
    ) : (
      <img
        src={avatarSrc}
        alt={onAvatarClick ? avatarAlt : ''}
        className="profile-identity-search-avatar"
        aria-hidden={onAvatarClick ? undefined : true}
      />
    );

  return (
    <div className="profile-identity-search">
      {onAvatarClick ? (
        <button
          type="button"
          className="profile-identity-search-avatar-button"
          onClick={onAvatarClick}
          aria-label={avatarAlt || 'View badge'}
        >
          {avatar}
        </button>
      ) : (
        avatar
      )}
      <div className="profile-identity-search-text">
        <PageProfileSearch
          selectedProfileId={selectedProfileId}
          onSelectProfile={onSelectProfile}
          onClear={onClear}
          className="profile-identity-search-select"
          defaultMenuOpen={defaultMenuOpen}
          autoFocus={autoFocus}
        />
        {children}
      </div>
    </div>
  );
};
